import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

const isAdminEmail = (email) => {
	const adminEmails = process.env.REACT_APP_ADMIN_EMAIL.replace("[", "")
		.replace("]", "")
		.split(",")
		.map((email) => email.trim().toLowerCase());
	return adminEmails.includes(email.toLowerCase());
};

function PrivateRoute({ children, adminOnly = false }) {
	const { currentUser } = useAuth();
	const [isInitialSetup, setIsInitialSetup] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function checkInitialSetup() {
			const usersQuery = collection(db, "users");
			const usersSnapshot = await getDocs(usersQuery);
			setIsInitialSetup(usersSnapshot.empty);
			setLoading(false);
		}
		checkInitialSetup();
	}, []);

	if (loading) {
		return null; // or a loading spinner
	}

	// Allow access if it's initial setup
	if (isInitialSetup) {
		return children;
	}

	// Normal authentication check
	if (!currentUser) {
		return <Navigate to="/login" />;
	}

	if (adminOnly && !isAdminEmail(currentUser.email)) {
		return <Navigate to="/" />;
	}

	return children;
}

export default PrivateRoute;
